/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface CircleGeometry {
    center: Point;
    /** @format double */
    radiusMeters: number;
}

export interface CommunityLocationRequestDto {
    /** @minLength 1 */
    name: string;
    geometryType: LocationGeometryType;
    polygon?: PolygonGeometry;
    circle?: CircleGeometry;
    restrictedForWorkoutRecording: boolean;
    recordedForArrivals: boolean;
}

export enum LocationGeometryType {
    POLYGON = 'POLYGON',
    CIRCLE = 'CIRCLE'
}

export interface Point {
    /** @format double */
    latitude: number;
    /** @format double */
    longitude: number;
}

export interface PolygonGeometry {
    points: Point[];
}

export interface CommunityLocationDto {
    /** @format int64 */
    id: number;
    /** @format int64 */
    communityId: number;
    /** @minLength 1 */
    communityName: string;
    /** @minLength 1 */
    name: string;
    geometryType: LocationGeometryType;
    polygon?: PolygonGeometry;
    circle?: CircleGeometry;
    restrictedForWorkoutRecording: boolean;
    recordedForArrivals: boolean;
    /** @format date-time */
    createdDate: string;
}

export interface CdnObjectDto {
    /** @minLength 1 */
    bucketName: string;
    /** @minLength 1 */
    objectKey: string;
}

export enum TeamAccess {
    OPEN = 'OPEN',
    REQUIRE_APPROVAL = 'REQUIRE_APPROVAL',
    INVITE_ONLY = 'INVITE_ONLY'
}

export enum TeamLeaderboardVisibility {
    NONE = 'NONE',
    FULL = 'FULL'
}

export enum TeamMemberVisibility {
    NONE = 'NONE',
    FULL = 'FULL'
}

export interface TeamUpdateSupportRequest {
    /** @minLength 1 */
    name: string;
    description?: string;
    image?: CdnObjectDto;
    access: TeamAccess;
    memberVisibility: TeamMemberVisibility;
    leaderboardVisibility: TeamLeaderboardVisibility;
    /** @format int32 */
    memberLimit?: number;
}

export interface CommunityShortInfoDto {
    /** @format int64 */
    id: number;
    /** @minLength 1 */
    name: string;
    description?: string;
    tenantId?: string;
    photo: CdnObjectDto;
}

export interface TeamDetailsSupportDto {
    /** @format int64 */
    id: number;
    /** @minLength 1 */
    name: string;
    description?: string;
    image?: CdnObjectDto;
    community: CommunityShortInfoDto;
    access: TeamAccess;
    memberVisibility: TeamMemberVisibility;
    leaderboardVisibility: TeamLeaderboardVisibility;
    /** @format int32 */
    memberLimit?: number;
    invitationCode?: string;
    /** @format int64 */
    memberCount: number;
    /** @format date-time */
    createdDate: string;
    /** @format date-time */
    modifiedDate?: string;
}

export enum TeamMemberRole {
    MANAGER = 'MANAGER',
    MEMBER = 'MEMBER'
}

export interface TeamMemberRoleUpdateRequestDto {
    role: TeamMemberRole;
}

export interface TeamMemberSupportDto {
    /** @format int64 */
    id: number;
    /** @minLength 1 */
    name: string;
    /** @minLength 1 */
    userId: string;
    role: TeamMemberRole;
    /** @format date */
    joinDay: string;
    /** @format date-time */
    createdDate: string;
}

export interface TeamMemberJoinDayUpdateRequestDto {
    /** @format date */
    joinDay: string;
}

export interface ScheduledPostRequestDto {
    /** @minLength 1 */
    contentMarkdown: string;
    /** @minLength 1 */
    authorUserId: string;
    /** @minLength 1 */
    authorName: string;
    image?: CdnObjectDto;
    /** @minItems 1 */
    communityIds: number[];
}

export interface ScheduledPostDto {
    /** @format int64 */
    id: number;
    contentMarkdown: string;
    authorUserId: string;
    authorName: string;
    image?: CdnObjectDto;
    status: ScheduledPostStatus;
    /** @format date-time */
    publishedDate?: string;
    /** @format date-time */
    createdDate: string;
    targets: ScheduledPostTargetDto[];
}

export enum ScheduledPostStatus {
    DRAFT = 'DRAFT',
    PLANNED = 'PLANNED',
    PENDING = 'PENDING',
    PUBLISHED = 'PUBLISHED',
    FAILED = 'FAILED'
}

export interface ScheduledPostTargetDto {
    /** @format int64 */
    communityId: number;
    communityName: string;
    status: ScheduledPostStatus;
    errorMessage?: string;
}

export enum CommunityMemberTag {
    OUT_OF_COMPETITION = 'OUT_OF_COMPETITION'
}

export interface CommunityMemberUpdateTagsRequestDto {
    /** @uniqueItems true */
    tags: CommunityMemberTag[];
}

export enum CommunityMemberRole {
    MEMBER = 'MEMBER',
    MANAGER = 'MANAGER'
}

export interface CommunityMemberSupportListEntryDto {
    /** @format int64 */
    id: number;
    name: string;
    userId: string;
    memberRole: CommunityMemberRole;
    verified: boolean;
    /** @format date */
    joinDay: string;
    /** @format date-time */
    createdDate: string;
    /** @uniqueItems true */
    tags: CommunityMemberTag[];
}

export interface CommunityMemberRoleUpdateRequestDto {
    role: CommunityMemberRole;
}

export interface CommunityMemberJoinDayUpdateRequestDto {
    /** @format date */
    joinDay: string;
}

export interface CommunitySetRoleRequestDto {
    role: CommunityMemberRole;
}

export interface CommunityUpdateRequestSupportDto {
    /** @minLength 1 */
    name: string;
    description?: I18NText;
    photo: CdnObjectDto;
    backgroundImage?: CdnObjectDto;
    /** @format int32 */
    memberLimit?: number;
    color?: string;
    approved: boolean;
    visibility: CommunityVisibility;
    pushNotificationEnabled: boolean;
    welcomeMessageEnabled: boolean;
    tenantMemberAutoJoinEnabled: boolean;
    currencyCode?: string;
    supportedLanguages: LanguageCode[];
    locale: LocaleCode;
    tenantId?: string;
}

export enum CommunityVisibility {
    PUBLIC = 'PUBLIC',
    PRIVATE = 'PRIVATE'
}

export interface I18NText {
    en?: string;
    de?: string;
    pl?: string;
    nb?: string;
    da?: string;
}

export enum LanguageCode {
    Undefined = 'undefined',
    Aa = 'aa',
    Ab = 'ab',
    Ae = 'ae',
    Af = 'af',
    Ak = 'ak',
    Am = 'am',
    An = 'an',
    Ar = 'ar',
    As = 'as',
    Av = 'av',
    Ay = 'ay',
    Az = 'az',
    Ba = 'ba',
    Be = 'be',
    Bg = 'bg',
    Bh = 'bh',
    Bi = 'bi',
    Bm = 'bm',
    Bn = 'bn',
    Bo = 'bo',
    Br = 'br',
    Bs = 'bs',
    Ca = 'ca',
    Ce = 'ce',
    Ch = 'ch',
    Co = 'co',
    Cr = 'cr',
    Cs = 'cs',
    Cu = 'cu',
    Cv = 'cv',
    Cy = 'cy',
    Da = 'da',
    De = 'de',
    Dv = 'dv',
    Dz = 'dz',
    Ee = 'ee',
    El = 'el',
    En = 'en',
    Eo = 'eo',
    Es = 'es',
    Et = 'et',
    Eu = 'eu',
    Fa = 'fa',
    Ff = 'ff',
    Fi = 'fi',
    Fj = 'fj',
    Fo = 'fo',
    Fr = 'fr',
    Fy = 'fy',
    Ga = 'ga',
    Gd = 'gd',
    Gl = 'gl',
    Gn = 'gn',
    Gu = 'gu',
    Gv = 'gv',
    Ha = 'ha',
    He = 'he',
    Hi = 'hi',
    Ho = 'ho',
    Hr = 'hr',
    Ht = 'ht',
    Hu = 'hu',
    Hy = 'hy',
    Hz = 'hz',
    Ia = 'ia',
    Id = 'id',
    Ie = 'ie',
    Ig = 'ig',
    Ii = 'ii',
    Ik = 'ik',
    Io = 'io',
    Is = 'is',
    It = 'it',
    Iu = 'iu',
    Ja = 'ja',
    Jv = 'jv',
    Ka = 'ka',
    Kg = 'kg',
    Ki = 'ki',
    Kj = 'kj',
    Kk = 'kk',
    Kl = 'kl',
    Km = 'km',
    Kn = 'kn',
    Ko = 'ko',
    Kr = 'kr',
    Ks = 'ks',
    Ku = 'ku',
    Kv = 'kv',
    Kw = 'kw',
    Ky = 'ky',
    La = 'la',
    Lb = 'lb',
    Lg = 'lg',
    Li = 'li',
    Ln = 'ln',
    Lo = 'lo',
    Lt = 'lt',
    Lu = 'lu',
    Lv = 'lv',
    Mg = 'mg',
    Mh = 'mh',
    Mi = 'mi',
    Mk = 'mk',
    Ml = 'ml',
    Mn = 'mn',
    Mr = 'mr',
    Ms = 'ms',
    Mt = 'mt',
    My = 'my',
    Na = 'na',
    Nb = 'nb',
    Nd = 'nd',
    Ne = 'ne',
    Ng = 'ng',
    Nl = 'nl',
    Nn = 'nn',
    No = 'no',
    Nr = 'nr',
    Nv = 'nv',
    Ny = 'ny',
    Oc = 'oc',
    Oj = 'oj',
    Om = 'om',
    Or = 'or',
    Os = 'os',
    Pa = 'pa',
    Pi = 'pi',
    Pl = 'pl',
    Ps = 'ps',
    Pt = 'pt',
    Qu = 'qu',
    Rm = 'rm',
    Rn = 'rn',
    Ro = 'ro',
    Ru = 'ru',
    Rw = 'rw',
    Sa = 'sa',
    Sc = 'sc',
    Sd = 'sd',
    Se = 'se',
    Sg = 'sg',
    Si = 'si',
    Sk = 'sk',
    Sl = 'sl',
    Sm = 'sm',
    Sn = 'sn',
    So = 'so',
    Sq = 'sq',
    Sr = 'sr',
    Ss = 'ss',
    St = 'st',
    Su = 'su',
    Sv = 'sv',
    Sw = 'sw',
    Ta = 'ta',
    Te = 'te',
    Tg = 'tg',
    Th = 'th',
    Ti = 'ti',
    Tk = 'tk',
    Tl = 'tl',
    Tn = 'tn',
    To = 'to',
    Tr = 'tr',
    Ts = 'ts',
    Tt = 'tt',
    Tw = 'tw',
    Ty = 'ty',
    Ug = 'ug',
    Uk = 'uk',
    Ur = 'ur',
    Uz = 'uz',
    Ve = 've',
    Vi = 'vi',
    Vo = 'vo',
    Wa = 'wa',
    Wo = 'wo',
    Xh = 'xh',
    Yi = 'yi',
    Yo = 'yo',
    Za = 'za',
    Zh = 'zh',
    Zu = 'zu'
}

export enum LocaleCode {
    UndefinedUNDEFINED = 'undefined-UNDEFINED',
    Ar = 'ar',
    ArAE = 'ar-AE',
    ArBH = 'ar-BH',
    ArDZ = 'ar-DZ',
    ArEG = 'ar-EG',
    ArIQ = 'ar-IQ',
    ArJO = 'ar-JO',
    ArKW = 'ar-KW',
    ArLB = 'ar-LB',
    ArLY = 'ar-LY',
    ArMA = 'ar-MA',
    ArOM = 'ar-OM',
    ArQA = 'ar-QA',
    ArSA = 'ar-SA',
    ArSD = 'ar-SD',
    ArSY = 'ar-SY',
    ArTN = 'ar-TN',
    ArYE = 'ar-YE',
    Be = 'be',
    BeBY = 'be-BY',
    Bg = 'bg',
    BgBG = 'bg-BG',
    Ca = 'ca',
    CaES = 'ca-ES',
    Cs = 'cs',
    CsCZ = 'cs-CZ',
    Da = 'da',
    DaDK = 'da-DK',
    De = 'de',
    DeAT = 'de-AT',
    DeCH = 'de-CH',
    DeDE = 'de-DE',
    DeLU = 'de-LU',
    El = 'el',
    ElCY = 'el-CY',
    ElGR = 'el-GR',
    En = 'en',
    EnAU = 'en-AU',
    EnCA = 'en-CA',
    EnGB = 'en-GB',
    EnHK = 'en-HK',
    EnIE = 'en-IE',
    EnIN = 'en-IN',
    EnMT = 'en-MT',
    EnNZ = 'en-NZ',
    EnPH = 'en-PH',
    EnSG = 'en-SG',
    EnUS = 'en-US',
    EnZA = 'en-ZA',
    Es = 'es',
    EsAR = 'es-AR',
    EsBO = 'es-BO',
    EsCL = 'es-CL',
    EsCO = 'es-CO',
    EsCR = 'es-CR',
    EsDO = 'es-DO',
    EsEC = 'es-EC',
    EsES = 'es-ES',
    EsGT = 'es-GT',
    EsHN = 'es-HN',
    EsMX = 'es-MX',
    EsNI = 'es-NI',
    EsPA = 'es-PA',
    EsPE = 'es-PE',
    EsPR = 'es-PR',
    EsPY = 'es-PY',
    EsSV = 'es-SV',
    EsUS = 'es-US',
    EsUY = 'es-UY',
    EsVE = 'es-VE',
    Et = 'et',
    EtEE = 'et-EE',
    Fa = 'fa',
    FaIR = 'fa-IR',
    Fi = 'fi',
    FiFI = 'fi-FI',
    Fr = 'fr',
    FrBE = 'fr-BE',
    FrCA = 'fr-CA',
    FrCH = 'fr-CH',
    FrFR = 'fr-FR',
    FrLU = 'fr-LU',
    Ga = 'ga',
    GaIE = 'ga-IE',
    He = 'he',
    HeIL = 'he-IL',
    HiIN = 'hi-IN',
    Hr = 'hr',
    HrHR = 'hr-HR',
    Hu = 'hu',
    HuHU = 'hu-HU',
    Id = 'id',
    IdID = 'id-ID',
    Is = 'is',
    IsIS = 'is-IS',
    It = 'it',
    ItCH = 'it-CH',
    ItIT = 'it-IT',
    Ja = 'ja',
    JaJP = 'ja-JP',
    KkKZ = 'kk-KZ',
    Ko = 'ko',
    KoKR = 'ko-KR',
    Lt = 'lt',
    LtLT = 'lt-LT',
    Lv = 'lv',
    LvLV = 'lv-LV',
    Mk = 'mk',
    MkMK = 'mk-MK',
    Ms = 'ms',
    MsMY = 'ms-MY',
    Mt = 'mt',
    MtMT = 'mt-MT',
    Nb = 'nb',
    NbNO = 'nb-NO',
    Nl = 'nl',
    NlBE = 'nl-BE',
    NlNL = 'nl-NL',
    NnNO = 'nn-NO',
    No = 'no',
    NoNO = 'no-NO',
    Pl = 'pl',
    PlPL = 'pl-PL',
    Pt = 'pt',
    PtBR = 'pt-BR',
    PtPT = 'pt-PT',
    Ro = 'ro',
    RoMD = 'ro-MD',
    RoRO = 'ro-RO',
    Ru = 'ru',
    RuKZ = 'ru-KZ',
    RuRU = 'ru-RU',
    Se = 'se',
    SeNO = 'se-NO',
    Sk = 'sk',
    SkSK = 'sk-SK',
    Sl = 'sl',
    SlSI = 'sl-SI',
    Sq = 'sq',
    SqAL = 'sq-AL',
    Sr = 'sr',
    SrBA = 'sr-BA',
    SrCS = 'sr-CS',
    SrME = 'sr-ME',
    SrRS = 'sr-RS',
    Sv = 'sv',
    SvSE = 'sv-SE',
    Th = 'th',
    ThTH = 'th-TH',
    Tr = 'tr',
    TrTR = 'tr-TR',
    Uk = 'uk',
    UkUA = 'uk-UA',
    Vi = 'vi',
    ViVN = 'vi-VN',
    Zh = 'zh',
    ZhCN = 'zh-CN',
    ZhHK = 'zh-HK',
    ZhSG = 'zh-SG',
    ZhTW = 'zh-TW'
}

export interface CommunityDetailsSupportDto {
    /** @format int64 */
    id: number;
    approved: boolean;
    licenseExpired: boolean;
    type: CommunityType;
    visibility: CommunityVisibility;
    /** @minLength 1 */
    name: string;
    description?: I18NText;
    photo: CdnObjectDto;
    backgroundImage?: CdnObjectDto;
    color?: string;
    currencyCode?: string;
    ownedCurrencyCodes: string[];
    chatId?: string;
    /** @format int32 */
    memberLimit?: number;
    /** @format date-time */
    createdDate: string;
    pushNotificationEnabled: boolean;
    welcomeMessageEnabled: boolean;
    tenantMemberAutoJoinEnabled: boolean;
    supportedLanguages: LanguageCode[];
    locale: LocaleCode;
    tenantId?: string;
    whitelabelId?: string;
    whitelabelEnabled: boolean;
    whitelabelShortName?: string;
    dashboardWidgets: CommunityWhitelabelDashboardWidgetDto[];
    joinConsents: Consent[];
}

export enum CommunityType {
    STANDARD = 'STANDARD',
    FRIENDS_AND_FAMILY = 'FRIENDS_AND_FAMILY',
    DEMO = 'DEMO',
    EXTERNAL_APP = 'EXTERNAL_APP'
}

export interface CommunityWhitelabelDashboardWidgetDto {
    enabled: boolean;
    title?: I18NText;
    text?: I18NText;
    image?: CdnObjectDto;
    link?: string;
    /** @format date-time */
    visibleFrom?: string;
    /** @format date-time */
    visibleTo?: string;
    layout: CommunityWhitelabelDashboardWidgetLayout;
    buttonLabel?: I18NText;
}

export enum CommunityWhitelabelDashboardWidgetLayout {
    HERO = 'HERO',
    HEADLINE = 'HEADLINE',
    COMPACT = 'COMPACT',
    BANNER = 'BANNER',
    ACCENT = 'ACCENT',
    STRIP = 'STRIP',
    POSTER = 'POSTER',
    SPLIT = 'SPLIT',
    CALL_TO_ACTION = 'CALL_TO_ACTION',
    TILE = 'TILE'
}

export interface Consent {
    text: I18NText;
    required: boolean;
    needsCheckbox: boolean;
    showAfterAccept: boolean;
}

export interface CommunityWhitelabelUpdateSupportDto {
    whitelabelId?: string;
    whitelabelEnabled: boolean;
    whitelabelShortName?: string;
    dashboardWidgets: CommunityWhitelabelDashboardWidgetDto[];
}

export interface ConsentUpdateDto {
    joinConsents: Consent[];
}

export enum ActivityType {
    DAILY_STEPS = 'DAILY_STEPS',
    FACILITY_VISIT = 'FACILITY_VISIT',
    WORKOUT = 'WORKOUT',
    PUSH_UP = 'PUSH_UP'
}

export enum ChatNotificationSelection {
    NONE = 'NONE',
    MENTIONS_AND_REPLIES = 'MENTIONS_AND_REPLIES',
    ALL = 'ALL'
}

export enum CommunityAccessLevel {
    ALL = 'ALL',
    MANAGERS = 'MANAGERS',
    NONE = 'NONE'
}

export interface CommunityApp {
    appId: string;
    /** @format date-time */
    installedDate: string;
    installedBy?: string;
}

export interface CommunitySettingsSupportDto {
    eventCreation: CommunityAccessLevel;
    memberInvitation: CommunityAccessLevel;
    notificationsChat: ChatNotificationSelection;
    leaveEnabled: boolean;
    achievementsEnabled: boolean;
    duelsEnabled: boolean;
    teamsEnabled: boolean;
    teamCreation: CommunityAccessLevel;
    chatModerationEnabled: boolean;
    challengeSubscriptionDetailsVisible: boolean;
    feedEnabled: boolean;
    fastrelayEnabled: boolean;
    liveEventsEnabled: boolean;
    /** @format int32 */
    defaultTeamMemberLimit?: number;
    singleTeamMembershipEnforced: boolean;
    feedPostCreation: CommunityAccessLevel;
    /** @uniqueItems true */
    excludedActivityTypes: ActivityType[];
    /** @uniqueItems true */
    excludedWorkoutCategories: WorkoutCategory[];
    /** @uniqueItems true */
    excludedWorkoutTypes: WorkoutTypeV2[];
    apps?: any[];
}

export enum WorkoutCategory {
    FOOT = 'FOOT',
    WHEELS = 'WHEELS',
    WATER = 'WATER',
    WINTER = 'WINTER',
    TEAM_SPORTS = 'TEAM_SPORTS',
    STATIONARY_TRAININGS = 'STATIONARY_TRAININGS',
    OTHER = 'OTHER'
}

export enum WorkoutTypeV2 {
    RUNNING = 'RUNNING',
    WALKING = 'WALKING',
    TREKKING = 'TREKKING',
    HIKING = 'HIKING',
    TREADMILL = 'TREADMILL',
    NORDIC_WALKING = 'NORDIC_WALKING',
    CYCLING = 'CYCLING',
    ELECTRIC_CYCLING = 'ELECTRIC_CYCLING',
    INDOOR_CYCLING = 'INDOOR_CYCLING',
    ROLLERBLADE = 'ROLLERBLADE',
    SKATEBOARD = 'SKATEBOARD',
    SCOOTER = 'SCOOTER',
    WHEELCHAIR = 'WHEELCHAIR',
    SKIING = 'SKIING',
    SNOWBOARDING = 'SNOWBOARDING',
    SKATING = 'SKATING',
    SKI_TOURING = 'SKI_TOURING',
    CROSS_COUNTRY_SKIING = 'CROSS_COUNTRY_SKIING',
    BIATHLON = 'BIATHLON',
    SWIMMING = 'SWIMMING',
    ROWING = 'ROWING',
    SURFING = 'SURFING',
    SAILING = 'SAILING',
    STAND_UP_PADDLE = 'STAND_UP_PADDLE',
    FOOTBALL = 'FOOTBALL',
    VOLLEYBALL = 'VOLLEYBALL',
    BASKETBALL = 'BASKETBALL',
    HANDBALL = 'HANDBALL',
    TRAINING = 'TRAINING',
    DANCING = 'DANCING',
    MARTIAL_ARTS = 'MARTIAL_ARTS',
    TENNIS = 'TENNIS',
    SQUASH = 'SQUASH',
    PADEL = 'PADEL',
    TABLE_TENNIS = 'TABLE_TENNIS',
    BADMINTON = 'BADMINTON',
    CLIMBING = 'CLIMBING',
    TREADMILL_TIME = 'TREADMILL_TIME',
    SWIMMING_TIME = 'SWIMMING_TIME',
    INDOOR_WALKING_TIME = 'INDOOR_WALKING_TIME',
    INDOOR_RUNNING_TIME = 'INDOOR_RUNNING_TIME',
    INDOOR_CYCLING_TIME = 'INDOOR_CYCLING_TIME',
    INDOOR_ROWING_TIME = 'INDOOR_ROWING_TIME',
    ELLIPTICAL = 'ELLIPTICAL',
    STRENGTH = 'STRENGTH',
    HIIT = 'HIIT',
    CARDIO = 'CARDIO',
    CROSSFIT = 'CROSSFIT',
    YOGA = 'YOGA',
    PILATES = 'PILATES',
    STRETCHING = 'STRETCHING',
    AEROBIC = 'AEROBIC',
    ZUMBA = 'ZUMBA',
    AQUA_GYM = 'AQUA_GYM',
    GOLF = 'GOLF',
    HORSE_RIDING = 'HORSE_RIDING',
    OTHER = 'OTHER'
}

export enum AggregationAlgorithm {
    SUM = 'SUM',
    AVERAGE = 'AVERAGE'
}

export enum ChallengeLeaderboardType {
    MEMBER = 'MEMBER',
    TEAM = 'TEAM',
    TEAM_MEMBER = 'TEAM_MEMBER'
}

export interface CommunityLeaderboardSettingsUpdateRequest {
    pointsAggregationType?: AggregationAlgorithm;
    dateFilters?: any[];
    activityCategoryFilters?: any[];
}

export interface LeaderboardActivityCategoryFilter {
    metric: LeaderboardMetric;
    label?: I18NText;
    activityType?: ActivityType;
    workoutCategory?: WorkoutCategory;
    workoutType?: WorkoutTypeV2;
    rewardCurrencyCode?: string;
    pointTypeKey?: string;
    /** @format int64 */
    challengeId?: number;
    challengeLeaderboardType?: ChallengeLeaderboardType;
    genderFilter: LeaderboardGenderMode;
    /** @format date */
    validFrom?: string;
    /** @format date */
    validTo?: string;
}

export interface LeaderboardDateFilter {
    filterType: LeaderboardDateFilterType;
    label?: I18NText;
    /** @format date */
    dateFrom?: string;
    /** @format date */
    dateTo?: string;
    /** @format date */
    validFrom?: string;
    /** @format date */
    validTo?: string;
}

export enum LeaderboardDateFilterType {
    TODAY = 'TODAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    LAST30DAYS = 'LAST_30_DAYS',
    LAST90DAYS = 'LAST_90_DAYS',
    CUSTOM = 'CUSTOM'
}

export enum LeaderboardGenderMode {
    DISABLED = 'DISABLED',
    SELECTABLE = 'SELECTABLE',
    MALE = 'MALE',
    FEMALE = 'FEMALE'
}

export enum LeaderboardMetric {
    ACTIVITY_POINTS = 'ACTIVITY_POINTS',
    STEPS = 'STEPS',
    DISTANCE = 'DISTANCE',
    TIME = 'TIME',
    REWARDS = 'REWARDS',
    COMPOSITE_POINTS = 'COMPOSITE_POINTS',
    CHALLENGE = 'CHALLENGE'
}

export interface CommunityLeaderboardSettingsSupportDto {
    pointsAggregationType: AggregationAlgorithm;
    dateFilters: LeaderboardDateFilter[];
    activityCategoryFilters: LeaderboardActivityCategoryFilter[];
}

export interface GeoRestrictionRequestDto {
    /** @minLength 1 */
    name: string;
    type: GeoRestrictionType;
    polygon?: PolygonGeometry;
    circle?: CircleGeometry;
}

export enum GeoRestrictionType {
    POLYGON = 'POLYGON',
    CIRCLE = 'CIRCLE'
}

export interface CommunityGeoRestrictionDto {
    /** @format int64 */
    id: number;
    /** @format int64 */
    communityId: number;
    /** @minLength 1 */
    communityName: string;
    /** @minLength 1 */
    name: string;
    type: GeoRestrictionType;
    polygon?: PolygonGeometry;
    circle?: CircleGeometry;
    restrictedForWorkoutRecording: boolean;
    recordedForArrivals: boolean;
    /** @format date-time */
    createdDate: string;
}

export interface CommunityBudgetChangeRequestSupportDto {
    /** @min 0 */
    budgetValue?: number;
    /** @min 0 */
    budgetHardCap?: number;
    /** @minLength 1 */
    comment: string;
}

export enum AverageCalculationVersion {
    V1 = 'V1',
    V2 = 'V2'
}

export interface ChallengeActivityFilterDto {
    activityType?: ActivityType;
    workoutCategory?: WorkoutCategory;
    workoutType?: WorkoutTypeV2;
    hasArrivalLocation?: boolean;
    minRawValue?: number;
    maxRawValue?: number;
    fitnessMetricType?: ChallengeFitnessMetricType;
}

export enum ChallengeActivityType {
    STEPS = 'STEPS',
    CYCLING = 'CYCLING',
    STUDIO_VISIT = 'STUDIO_VISIT'
}

export enum ChallengeAggregationType {
    SUM = 'SUM',
    MAX = 'MAX',
    MIN = 'MIN'
}

export interface ChallengeCollectiveRuleSetDto {
    /** @exclusiveMin 0 */
    activityPointsGoal: number;
    reward?: MoneyValueDto;
}

export interface ChallengeDisplayNormalizationFormulaDto {
    operation: ChallengeNormalizationOperation;
    /** @exclusiveMin 0 */
    operand: number;
    outputFormat: ChallengeNormalizationOutputFormat;
}

export enum ChallengeFitnessMetricType {
    DISTANCE = 'DISTANCE',
    ACTIVITY_TIME_IN_MINUTES = 'ACTIVITY_TIME_IN_MINUTES',
    STEPS = 'STEPS',
    CALORIES = 'CALORIES',
    PACE = 'PACE',
    WORKOUT_CALCULATED_METRIC = 'WORKOUT_CALCULATED_METRIC',
    REPS = 'REPS'
}

export enum ChallengeInitialResultMode {
    CURRENT_DAY_ONLY = 'CURRENT_DAY_ONLY',
    INCREMENTAL = 'INCREMENTAL'
}

export enum ChallengeNormalizationOperation {
    MULTIPLY = 'MULTIPLY'
}

export enum ChallengeNormalizationOutputFormat {
    DURATION = 'DURATION',
    NUMBER = 'NUMBER'
}

export interface ChallengePersonalRuleSetDto {
    leaderboardEnabled: boolean;
    strategyConfig: ChallengeStrategyConfig;
    /** @exclusiveMin 0 */
    qualificationThreshold?: number;
}

export interface ChallengeRuleConfigUpdateDto {
    activityType?: ActivityType;
    workoutCategory?: WorkoutCategory;
    compositePointTypeKey?: string;
    ruleType: ChallengeRuleType;
    fitnessMetricType?: ChallengeFitnessMetricType;
    calculatedMetricKey?: string;
    aggregationType: ChallengeAggregationType;
    initialResultMode?: ChallengeInitialResultMode;
    resultBaseline?: number;
    displayNormalizationFormula?: ChallengeDisplayNormalizationFormulaDto;
    recordAttempts: boolean;
    activityFilters: ChallengeActivityFilterDto[];
    /**
     * Use activityType and workoutCategory instead
     * @deprecated
     */
    supportedActivityTypes?: any[];
    dateTimeRange: ZonedDateTimeRangeDto;
    /** @format date-time */
    joinDeadline?: string;
    personalRuleSet: ChallengePersonalRuleSetDto;
    teamRuleSet?: ChallengeTeamRuleSetDto;
    groupRules: ChallengeCollectiveRuleSetDto[];
}

export enum ChallengeRuleType {
    ACTIVITY_POINTS = 'ACTIVITY_POINTS',
    ACTIVITY_RAW_VALUE = 'ACTIVITY_RAW_VALUE',
    ACTIVITY_COUNT = 'ACTIVITY_COUNT'
}

export interface ChallengeStrategyConfig {
    strategy: ChallengeType;
    pointsGoal?: number;
    /** @format int32 */
    allowedWinnersCount?: number;
}

export interface ChallengeTeamRuleSetDto {
    leaderboardEnabled: boolean;
    pointsAlgorithm: AggregationAlgorithm;
    /** @format int32 */
    winnersCount?: number;
    /** @format int32 */
    minimumTeamSize?: number;
    averageCalculationVersion?: AverageCalculationVersion;
}

export enum ChallengeType {
    RACE = 'RACE',
    HIGH_SCORE = 'HIGH_SCORE'
}

export interface MoneyValueDto {
    value: number;
    /** @minLength 1 */
    currencyCode: string;
}

export interface ZonedDateTimeRangeDto {
    /** @format date-time */
    from: string;
    /** @format date-time */
    to: string;
}

export interface BadgeRewardDto {
    /** @format int64 */
    badgeTypeId: number;
    /** @format int32 */
    badgeLevelIndex?: number;
    badgeName?: I18NText;
    badgeImageUrl?: string;
}

export interface ChallengeDetailsSupportDto {
    /** @format int64 */
    id: number;
    status: ChallengeStatus;
    presentation: ChallengePresentationSupportDto;
    community: CommunityShortInfoDto;
    rule: ChallengeRuleConfigDto;
    autoJoinEnabled: boolean;
    joinConsents: Consent[];
    leaderboardEditable: boolean;
    teamsLeaderboardEnabled: boolean;
    rewardConfig?: ChallengeRewardConfigDto;
}

export interface ChallengePresentationSupportDto {
    name: I18NText;
    prizeDescription?: I18NText;
    photo: CdnObjectDto;
}

export interface ChallengeRewardConfigDto {
    rewardType: RewardType;
    badge?: BadgeRewardDto;
    currency?: CurrencyRewardDto;
}

export interface ChallengeRuleConfigDto {
    activityType?: ActivityType;
    workoutCategory?: WorkoutCategory;
    compositePointTypeKey?: string;
    ruleType: ChallengeRuleType;
    fitnessMetricType?: ChallengeFitnessMetricType;
    calculatedMetricKey?: string;
    liveEventType?: LiveEventType;
    aggregationType: ChallengeAggregationType;
    initialResultMode: ChallengeInitialResultMode;
    resultBaseline?: number;
    displayNormalizationFormula?: ChallengeDisplayNormalizationFormulaDto;
    recordAttempts: boolean;
    activityFilters: ChallengeActivityFilterDto[];
    /**
     * Use activityType and workoutCategory instead
     * @deprecated
     */
    supportedActivityTypes?: any[];
    dateTimeRange: ZonedDateTimeRangeDto;
    /** @format date-time */
    joinDeadline?: string;
    personalRuleSet?: ChallengePersonalRuleSetDto;
    teamRuleSet?: ChallengeTeamRuleSetDto;
    groupRules: ChallengeCollectiveRuleSetDto[];
}

export enum ChallengeStatus {
    DRAFT = 'DRAFT',
    SCHEDULED = 'SCHEDULED',
    PUBLISHED = 'PUBLISHED',
    IN_PROGRESS = 'IN_PROGRESS',
    FINISHED = 'FINISHED',
    CANCELED = 'CANCELED'
}

export interface CurrencyRewardDto {
    reward: MoneyValueDto;
}

export enum LiveEventType {
    PUSHUPS = 'PUSHUPS',
    WALK = 'WALK',
    RUN = 'RUN',
    WORKOUT = 'WORKOUT'
}

export enum RewardType {
    BADGE = 'BADGE',
    CURRENCY = 'CURRENCY'
}

export interface ChallengeJoinConsentUpdateDto {
    joinConsents: Consent[];
}

export interface ChallengeGroupRulesUpdateDto {
    groupRules: ChallengeCollectiveRuleSetDto[];
}

export interface ChallengeTeamMemberResultUpdateSupportDto {
    /** @format int64 */
    subscriptionId: number;
    /** @min 0 */
    value: number;
}

export interface ChallengeTeamMemberResultsUpdateRequestSupportDto {
    members: ChallengeTeamMemberResultUpdateSupportDto[];
}

export interface ChallengeTeamMemberResultSupportDto {
    /** @format int64 */
    subscriptionId: number;
    userId: string;
    userName: string;
    userImage: CdnObjectDto;
    value: number;
}

export interface ChallengeTeamMemberResultsSupportDto {
    /** @format int64 */
    teamSubscriptionId: number;
    /** @format int64 */
    teamId: number;
    teamName: string;
    pointsAlgorithm: AggregationAlgorithm;
    result: number;
    sum: number;
    average: number;
    /** @format int32 */
    memberCount: number;
    members: ChallengeTeamMemberResultSupportDto[];
}

export interface ChallengeTeamDailyResultUpdateSupportDto {
    /** @format date */
    day: string;
    /** @min 0 */
    value: number;
    /**
     * @format int32
     * @min 0
     */
    memberCount: number;
}

export interface ChallengeTeamDailyResultsUpdateRequestSupportDto {
    days: ChallengeTeamDailyResultUpdateSupportDto[];
}

export interface ChallengeTeamDailyResultSupportDto {
    /** @format date */
    day: string;
    value: number;
    /** @format int32 */
    memberCount: number;
    average: number;
}

export interface ChallengeTeamDailyResultsSupportDto {
    /** @format int64 */
    teamSubscriptionId: number;
    /** @format int64 */
    teamId: number;
    teamName: string;
    pointsAlgorithm: AggregationAlgorithm;
    averageCalculationVersion: AverageCalculationVersion;
    result: number;
    sum: number;
    average: number;
    /** @format int32 */
    memberCount: number;
    days: ChallengeTeamDailyResultSupportDto[];
}

export interface ChallengeMemberResultUpdateRequestDto {
    /** @min 0 */
    value: number;
    /** @format date */
    day?: string;
}

export interface ChallengeLeaderboardEntrySupportDto {
    /** @format int64 */
    subscriptionId: number;
    userId: string;
    userName: string;
    userImage: CdnObjectDto;
    /** @format int32 */
    position: number;
    result: number;
    /** @format date-time */
    joinTimestamp: string;
    /** @format date-time */
    wonDate?: string;
    /** @format int64 */
    teamId?: number;
    teamName?: string;
    roleLabel?: I18NText;
    roleIconSvg?: string;
    pinned: boolean;
}

export interface ChallengeMemberJoinDateUpdateRequestDto {
    /** @format date-time */
    createdDate: string;
}

export interface ChallengeMemberDisplaySettingsUpdateRequestDto {
    roleLabel?: I18NText;
    roleIconSvg?: string;
    pinned: boolean;
}

export interface InvitationCodeDto {
    /** @minLength 1 */
    invitationCode: string;
}

export interface SchedulePostRequestDto {
    /** @format date-time */
    publishedDate?: string;
    publishNow: boolean;
}

export interface ValidateAuthorMembershipRequestDto {
    /** @minLength 1 */
    authorUserId: string;
    communityIds: number[];
}

export interface AuthorMembershipResultDto {
    valid: boolean;
    missingCommunities: MissingCommunityDto[];
}

export interface MissingCommunityDto {
    /** @format int64 */
    id: number;
    name: string;
}

export enum ImageType {
    COMMUNITY = 'COMMUNITY',
    COMMUNITY_EVENT = 'COMMUNITY_EVENT',
    COMMUNITY_MEMBER = 'COMMUNITY_MEMBER',
    TEAM = 'TEAM',
    FEED_POST = 'FEED_POST'
}

export interface CommunityResultSupportRequestDto {
    /** @format int64 */
    communityId?: number;
    /** @format date */
    from: string;
    /** @format date */
    to: string;
}

export interface CommunityResultSupportResponseDto {
    /** @format int64 */
    id: number;
}

export interface CommunityMemberResultMetricsInit {
    userIds: string[];
    /** @format date */
    dayFromInclusive: string;
    /** @format date */
    dayToInclusive: string;
}

export interface CommunityFeedSyncRequest {
    communityIds?: any[];
}

export interface CommunityCreateRequestSupportDto {
    /** @minLength 1 */
    name: string;
    type: CommunityType;
    tenantId?: string;
    description?: I18NText;
    photo: CdnObjectDto;
    managerUserIds: string[];
    memberInvitation: CommunityAccessLevel;
    eventCreation: CommunityAccessLevel;
    tenantMemberAutoJoinEnabled: boolean;
    leaveEnabled: boolean;
    initMembers: boolean;
    notificationsChat: ChatNotificationSelection;
    locale: LocaleCode;
}

export interface CommunityDto {
    /** @format int64 */
    id: number;
    approved: boolean;
    licenseExpired: boolean;
    type: CommunityType;
    visibility: CommunityVisibility;
    /** @minLength 1 */
    name: string;
    description?: string;
    photo: CdnObjectDto;
    color?: string;
    currencyCode?: string;
    ownedCurrencyCodes: string[];
    /** @format date-time */
    createdDate: string;
    tenantId?: string;
}

export interface TeamCreateSupportRequest {
    /** @minLength 1 */
    name: string;
    /** @minLength 1 */
    description: string;
    image: CdnObjectDto;
    access: TeamAccess;
    memberVisibility: TeamMemberVisibility;
    leaderboardVisibility: TeamLeaderboardVisibility;
    /** @minLength 1 */
    managerUserId: string;
    /** @format int32 */
    memberLimit?: number;
}

export interface CommunityRecapRequestDto {
    /** @format date */
    from: string;
    /** @format date */
    to: string;
    pending: boolean;
}

export interface FacilityRestrictionCreateRequestDto {
    /** @format int64 */
    facilityId: number;
    /** @minLength 1 */
    facilityName: string;
}

export interface FacilityRestrictionDto {
    /** @format int64 */
    id: number;
    /** @format int64 */
    facilityId: number;
    /** @minLength 1 */
    facilityName: string;
    type: RestrictionType;
    /** @format int64 */
    communityId: number;
    /** @minLength 1 */
    communityName: string;
    /** @format date-time */
    createdDate: string;
}

export enum RestrictionType {
    BLOCKED = 'BLOCKED'
}

export enum ChallengeMode {
    DUEL = 'DUEL',
    LIVE_EVENT = 'LIVE_EVENT'
}

export interface CommunityChallengeCreateRequestDto {
    /** @format int64 */
    communityId: number;
    name: I18NText;
    prizeDescription: I18NText;
    photo: CdnObjectDto;
    dateTimeRange: ZonedDateTimeRangeDto;
    /** @format date-time */
    joinDeadline?: string;
    autoJoinEnabled: boolean;
    personalRuleSet: ChallengePersonalRuleSetDto;
    activityType?: ActivityType;
    workoutCategory?: WorkoutCategory;
    compositePointTypeKey?: string;
    ruleType: ChallengeRuleType;
    fitnessMetricType?: ChallengeFitnessMetricType;
    calculatedMetricKey?: string;
    aggregationType: ChallengeAggregationType;
    initialResultMode?: ChallengeInitialResultMode;
    resultBaseline?: number;
    displayNormalizationFormula?: ChallengeDisplayNormalizationFormulaDto;
    recordAttempts: boolean;
    activityFilters: ChallengeActivityFilterDto[];
    /**
     * Use activityType and workoutCategory instead
     * @deprecated
     * @uniqueItems true
     */
    supportedActivityTypes?: any[];
    teamRuleSet?: ChallengeTeamRuleSetDto;
    groupRules: ChallengeCollectiveRuleSetDto[];
    joinConsents: Consent[];
    mode?: ChallengeMode;
    rewardConfig?: ChallengeRewardConfigDto;
}

export interface ChallengeAverageCalculationMigrationSupportDto {
    /** @format int64 */
    challengeId: number;
    previousVersion: AverageCalculationVersion;
    currentVersion: AverageCalculationVersion;
    /** @format int32 */
    migratedTeamCount: number;
    /** @format int32 */
    recreatedDailyResultCount: number;
}

export interface ChallengeLeaderboardEntryCreateRequestSupportDto {
    /** @minLength 1 */
    userId: string;
    /** @min 0 */
    value: number;
    /** @format date */
    day?: string;
    type?: ChallengeSubscriptionType;
}

export enum ChallengeSubscriptionType {
    MEMBER = 'MEMBER',
    TEAM = 'TEAM'
}

export interface BasicLeaderboardEntryDto {
    /** @minLength 1 */
    name: string;
    /** @format int32 */
    position: number;
    points: number;
}

export interface CommunityBudgetUsageCorrectionRequestSupportDto {
    value: number;
    /** @minLength 1 */
    comment: string;
}

export interface CommunityBudgetUsageSupportDto {
    /** @format int64 */
    id: number;
    yearMonth: string;
    /** @minLength 1 */
    currencyCode: string;
    userId?: string;
    /** @format int64 */
    goalId?: number;
    /** @format int64 */
    rewardId?: number;
    value: number;
    /** @format date-time */
    occurredAt: string;
    /** @format int64 */
    correctsUsageId?: number;
    comment?: string;
    /** @minLength 1 */
    createdBy: string;
    /** @format date-time */
    createdDate: string;
}

export enum Job {
    INIT_COMMUNITY_RESULT_HISTORICAL_DATA = 'INIT_COMMUNITY_RESULT_HISTORICAL_DATA',
    RECALCULATE_CHALLENGE_SUBSCRIPTIONS = 'RECALCULATE_CHALLENGE_SUBSCRIPTIONS',
    SEND_TEAM_WELCOME_MESSAGES = 'SEND_TEAM_WELCOME_MESSAGES',
    SEND_COMMUNITY_WELCOME_MESSAGES = 'SEND_COMMUNITY_WELCOME_MESSAGES',
    UPDATE_CHALLENGE_POSITIONS = 'UPDATE_CHALLENGE_POSITIONS',
    COMPACT_USER_METRICS = 'COMPACT_USER_METRICS',
    FIX_FEED_MENTION_FORMAT = 'FIX_FEED_MENTION_FORMAT',
    BACKFILL_USER_ACCOUNTS = 'BACKFILL_USER_ACCOUNTS'
}

export interface PageCommunityLocationDto {
    content: CommunityLocationDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface CommunityMembershipInfoSupportDto {
    communities: UserCommunitySupportDto[];
    teams: UserTeamSupportDto[];
    challenges: UserChallengeSupportDto[];
}

export interface UserChallengeSupportDto {
    /** @format int64 */
    id: number;
    name: I18NText;
    status: ChallengeStatus;
    /** @format int64 */
    communityId?: number;
    communityName?: string;
    /** @format date-time */
    joinedDate: string;
    points: number;
    /** @format int32 */
    position: number;
    /** @format date-time */
    lastSyncTimestamp?: string;
    won: boolean;
}

export interface UserCommunitySupportDto {
    /** @format int64 */
    id: number;
    /** @minLength 1 */
    name: string;
    verified: boolean;
}

export interface UserTeamSupportDto {
    /** @format int64 */
    id: number;
    /** @minLength 1 */
    name: string;
    /** @format int64 */
    communityId: number;
}

export interface PageTeamSupportDto {
    content: TeamSupportDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface TeamSupportDto {
    /** @format int64 */
    id: number;
    /** @minLength 1 */
    name: string;
    image: CdnObjectDto;
    community: CommunityShortInfoDto;
    access: TeamAccess;
    /** @format int64 */
    memberCount: number;
    invitationCode?: string;
}

export interface PageTeamMemberSupportDto {
    content: TeamMemberSupportDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface AdminLeaderboardMemberEntryDto {
    /** @format int32 */
    position: number;
    /** @format int64 */
    memberId: number;
    userId: string;
    profileId?: string;
    name: string;
    firstName: string;
    lastName: string;
    emails: string[];
    image: CdnObjectDto;
    userType: string;
    /** @uniqueItems true */
    tags: CommunityMemberTag[];
    points: number;
}

export interface AdminLeaderboardMemberPreviewResponse {
    content: AdminLeaderboardMemberEntryDto[];
    /** @format int32 */
    page: number;
    /** @format int32 */
    size: number;
    /** @format int64 */
    totalElements: number;
    /** @format int32 */
    totalPages: number;
}

export interface SupportFeedAttachmentDto {
    type?: string;
    title?: string;
    text?: string;
    imageUrl?: string;
    thumbUrl?: string;
    assetUrl?: string;
    titleLink?: string;
    authorName?: string;
    ogScrapeUrl?: string;
    custom?: object;
}

export interface SupportFeedEntryDto {
    /** @minLength 1 */
    id: string;
    text?: string;
    /** @format date-time */
    createdDate?: string;
    /** @format date-time */
    updatedDate?: string;
    author?: SupportFeedUserDto;
    mentionedUsers: SupportFeedUserDto[];
    attachments: SupportFeedAttachmentDto[];
    /** @format int32 */
    commentCount: number;
    topicModerationApproved?: boolean;
    pinned: boolean;
}

export interface SupportFeedPageDto {
    items: SupportFeedEntryDto[];
    next?: string;
    hasMore: boolean;
}

export interface SupportFeedUserDto {
    /** @minLength 1 */
    streamUserId: string;
    userId?: string;
    name?: string;
    image?: string;
}

export interface SupportFeedCommentDto {
    /** @minLength 1 */
    id: string;
    text?: string;
    /** @format date-time */
    createdDate?: string;
    /** @format date-time */
    updatedDate?: string;
    author?: SupportFeedUserDto;
    mentionedUsers: SupportFeedUserDto[];
    attachments: SupportFeedAttachmentDto[];
    topicModerationApproved?: boolean;
}

export interface SupportFeedCommentPageDto {
    items: SupportFeedCommentDto[];
    next?: string;
    hasMore: boolean;
}

export interface PageScheduledPostDto {
    content: ScheduledPostDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface PageCommunityMemberSupportListEntryDto {
    content: CommunityMemberSupportListEntryDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface CommunityPageEntrySupportDto {
    /** @format int64 */
    id: number;
    approved: boolean;
    licenseExpired: boolean;
    type: CommunityType;
    visibility: CommunityVisibility;
    /** @minLength 1 */
    name: string;
    description?: string;
    photo: CdnObjectDto;
    currencyCode?: string;
    ownedCurrencyCodes: string[];
    /** @format date-time */
    createdDate: string;
    tenantId?: string;
    whitelabelId?: string;
    whitelabelEnabled: boolean;
    /** @minLength 1 */
    invitationCode: string;
}

export interface PageCommunityPageEntrySupportDto {
    content: CommunityPageEntrySupportDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface AdminTeamLeaderboardEntryDto {
    /** @format int32 */
    position: number;
    /** @format int64 */
    teamId: number;
    name: string;
    image: CdnObjectDto;
    /** @format int64 */
    memberCount: number;
    points: number;
}

export interface AdminTeamLeaderboardPreviewResponse {
    content: AdminTeamLeaderboardEntryDto[];
    /** @format int32 */
    page: number;
    /** @format int32 */
    size: number;
}

export interface CommunityBudgetCurrencySupportDto {
    /** @minLength 1 */
    currencyCode: string;
    budgetValue?: number;
    budgetHardCap?: number;
    currentPeriod?: CommunityBudgetPeriodSupportDto;
    /** @minLength 1 */
    modifiedBy: string;
    /** @format date-time */
    modifiedDate: string;
}

export interface CommunityBudgetPeriodSupportDto {
    yearMonth: string;
    /** @minLength 1 */
    currencyCode: string;
    budgetValue?: number;
    budgetHardCap?: number;
    currentUsage: number;
    /** @format date-time */
    budgetValueReachedAt?: string;
    /** @format date-time */
    budgetHardCapReachedAt?: string;
}

export interface CommunityBudgetSupportDto {
    /** @format int64 */
    communityId: number;
    currencies: CommunityBudgetCurrencySupportDto[];
}

export interface ChallengePageEntrySupportDto {
    /** @format int64 */
    id: number;
    status: ChallengeStatus;
    presentation: ChallengePresentationSupportDto;
    dateTimeRange: ZonedDateTimeRangeDto;
    community: CommunityShortInfoDto;
    leaderboardEditable: boolean;
    teamsLeaderboardEnabled: boolean;
    invitationCode?: string;
}

export interface PageChallengePageEntrySupportDto {
    content: ChallengePageEntrySupportDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface ChallengeTeamLeaderboardEntrySupportDto {
    /** @format int64 */
    teamSubscriptionId: number;
    /** @format int64 */
    teamId: number;
    teamName: string;
    teamImage: CdnObjectDto;
    /** @format int32 */
    position: number;
    result: number;
    sum: number;
    average: number;
    /** @format int32 */
    memberCount: number;
    /** @format date-time */
    wonDate?: string;
}

export interface PageChallengeTeamLeaderboardEntrySupportDto {
    content: ChallengeTeamLeaderboardEntrySupportDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface PageChallengeLeaderboardEntrySupportDto {
    content: ChallengeLeaderboardEntrySupportDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export interface ChallengePhotoSearchResponseDto {
    content: CdnObjectDto[];
    nextContinuationToken?: string;
}

export interface PageCommunityBudgetUsageSupportDto {
    content: CommunityBudgetUsageSupportDto[];
    /**
     * @format int32
     * @min 0
     */
    number: number;
    /**
     * @format int32
     * @min 0
     */
    size: number;
    /**
     * @format int32
     * @min 0
     */
    totalPages: number;
    /**
     * @format int64
     * @min 0
     */
    totalElements: number;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
    /** set parameter to `true` for call `securityWorker` for this request */
    secure?: boolean;
    /** request path */
    path: string;
    /** content type of request body */
    type?: ContentType;
    /** query params */
    query?: QueryParamsType;
    /** format of response (i.e. response.json() -> format: "json") */
    format?: ResponseFormat;
    /** request body */
    body?: unknown;
    /** base url */
    baseUrl?: string;
    /** request cancellation token */
    cancelToken?: CancelToken;
}

export type RequestParams = Omit<
    FullRequestParams,
    'body' | 'method' | 'query' | 'path'
>;

export interface ApiConfig<SecurityDataType = unknown> {
    baseUrl?: string;
    baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
    securityWorker?: (
        securityData: SecurityDataType | null
    ) => Promise<RequestParams | void> | RequestParams | void;
    customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
    extends Response {
    data: D;
    error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
    Json = 'application/json',
    FormData = 'multipart/form-data',
    UrlEncoded = 'application/x-www-form-urlencoded',
    Text = 'text/plain'
}

export class HttpClient<SecurityDataType = unknown> {
    public baseUrl: string = '/challenge-api';
    private securityData: SecurityDataType | null = null;
    private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
    private abortControllers = new Map<CancelToken, AbortController>();
    private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
        fetch(...fetchParams);

    private baseApiParams: RequestParams = {
        credentials: 'same-origin',
        headers: {},
        redirect: 'follow',
        referrerPolicy: 'no-referrer'
    };

    constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
        Object.assign(this, apiConfig);
    }

    public setSecurityData = (data: SecurityDataType | null) => {
        this.securityData = data;
    };

    protected encodeQueryParam(key: string, value: any) {
        const encodedKey = encodeURIComponent(key);
        return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
    }

    protected addQueryParam(query: QueryParamsType, key: string) {
        return this.encodeQueryParam(key, query[key]);
    }

    protected addArrayQueryParam(query: QueryParamsType, key: string) {
        const value = query[key];
        return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
    }

    protected toQueryString(rawQuery?: QueryParamsType): string {
        const query = rawQuery || {};
        const keys = Object.keys(query).filter(
            (key) => 'undefined' !== typeof query[key]
        );
        return keys
            .map((key) =>
                Array.isArray(query[key])
                    ? this.addArrayQueryParam(query, key)
                    : this.addQueryParam(query, key)
            )
            .join('&');
    }

    protected addQueryParams(rawQuery?: QueryParamsType): string {
        const queryString = this.toQueryString(rawQuery);
        return queryString ? `?${queryString}` : '';
    }

    private contentFormatters: Record<ContentType, (input: any) => any> = {
        [ContentType.Json]: (input: any) =>
            input !== null &&
            (typeof input === 'object' || typeof input === 'string')
                ? JSON.stringify(input)
                : input,
        [ContentType.Text]: (input: any) =>
            input !== null && typeof input !== 'string'
                ? JSON.stringify(input)
                : input,
        [ContentType.FormData]: (input: any) =>
            Object.keys(input || {}).reduce((formData, key) => {
                const property = input[key];
                formData.append(
                    key,
                    property instanceof Blob
                        ? property
                        : typeof property === 'object' && property !== null
                          ? JSON.stringify(property)
                          : `${property}`
                );
                return formData;
            }, new FormData()),
        [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input)
    };

    protected mergeRequestParams(
        params1: RequestParams,
        params2?: RequestParams
    ): RequestParams {
        return {
            ...this.baseApiParams,
            ...params1,
            ...(params2 || {}),
            headers: {
                ...(this.baseApiParams.headers || {}),
                ...(params1.headers || {}),
                ...((params2 && params2.headers) || {})
            }
        };
    }

    protected createAbortSignal = (
        cancelToken: CancelToken
    ): AbortSignal | undefined => {
        if (this.abortControllers.has(cancelToken)) {
            const abortController = this.abortControllers.get(cancelToken);
            if (abortController) {
                return abortController.signal;
            }
            return void 0;
        }

        const abortController = new AbortController();
        this.abortControllers.set(cancelToken, abortController);
        return abortController.signal;
    };

    public abortRequest = (cancelToken: CancelToken) => {
        const abortController = this.abortControllers.get(cancelToken);

        if (abortController) {
            abortController.abort();
            this.abortControllers.delete(cancelToken);
        }
    };

    public request = async <T = any, E = any>({
        body,
        secure,
        path,
        type,
        query,
        format,
        baseUrl,
        cancelToken,
        ...params
    }: FullRequestParams): Promise<HttpResponse<T, E>> => {
        const secureParams =
            ((typeof secure === 'boolean'
                ? secure
                : this.baseApiParams.secure) &&
                this.securityWorker &&
                (await this.securityWorker(this.securityData))) ||
            {};
        const requestParams = this.mergeRequestParams(params, secureParams);
        const queryString = query && this.toQueryString(query);
        const payloadFormatter =
            this.contentFormatters[type || ContentType.Json];
        const responseFormat = format || requestParams.format;

        return this.customFetch(
            `${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`,
            {
                ...requestParams,
                headers: {
                    ...(requestParams.headers || {}),
                    ...(type && type !== ContentType.FormData
                        ? { 'Content-Type': type }
                        : {})
                },
                signal:
                    (cancelToken
                        ? this.createAbortSignal(cancelToken)
                        : requestParams.signal) || null,
                body:
                    typeof body === 'undefined' || body === null
                        ? null
                        : payloadFormatter(body)
            }
        ).then(async (response) => {
            const r = response.clone() as HttpResponse<T, E>;
            r.data = null as unknown as T;
            r.error = null as unknown as E;

            const data = !responseFormat
                ? r
                : await response[responseFormat]()
                      .then((data) => {
                          if (r.ok) {
                              r.data = data;
                          } else {
                              r.error = data;
                          }
                          return r;
                      })
                      .catch((e) => {
                          r.error = e;
                          return r;
                      });

            if (cancelToken) {
                this.abortControllers.delete(cancelToken);
            }

            if (!response.ok) throw data;
            return data;
        });
    };
}

/**
 * @title OpenAPI definition
 * @version v0
 * @baseUrl /challenge-api
 */
export class Api<
    SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
    support = {
        /**
         * No description
         *
         * @tags community-location-support-controller
         * @name CommunityLocationSupportControllerUpdate
         * @request PUT:/support/v2/communities/{communityId}/locations/{locationId}
         * @secure
         */
        communityLocationSupportControllerUpdate: (
            communityId: number,
            locationId: number,
            data: CommunityLocationRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityLocationDto, any>({
                path: `/support/v2/communities/${communityId}/locations/${locationId}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-location-support-controller
         * @name CommunityLocationSupportControllerDelete
         * @request DELETE:/support/v2/communities/{communityId}/locations/{locationId}
         * @secure
         */
        communityLocationSupportControllerDelete: (
            communityId: number,
            locationId: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v2/communities/${communityId}/locations/${locationId}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerGetById
         * @request GET:/support/v1/teams/{teamId}
         * @secure
         */
        teamSupportControllerGetById: (
            teamId: number,
            params: RequestParams = {}
        ) =>
            this.request<TeamDetailsSupportDto, any>({
                path: `/support/v1/teams/${teamId}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerUpdate
         * @request PUT:/support/v1/teams/{teamId}
         * @secure
         */
        teamSupportControllerUpdate: (
            teamId: number,
            data: TeamUpdateSupportRequest,
            params: RequestParams = {}
        ) =>
            this.request<TeamDetailsSupportDto, any>({
                path: `/support/v1/teams/${teamId}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerDeleteTeam
         * @request DELETE:/support/v1/teams/{teamId}
         * @secure
         */
        teamSupportControllerDeleteTeam: (
            teamId: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/teams/${teamId}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerUpdateMemberRole
         * @request PUT:/support/v1/teams/{teamId}/members/{teamMemberId}/role
         * @secure
         */
        teamSupportControllerUpdateMemberRole: (
            teamId: number,
            teamMemberId: number,
            data: TeamMemberRoleUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<TeamMemberSupportDto, any>({
                path: `/support/v1/teams/${teamId}/members/${teamMemberId}/role`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerUpdateMemberJoinDay
         * @request PUT:/support/v1/teams/{teamId}/members/{teamMemberId}/join-day
         * @secure
         */
        teamSupportControllerUpdateMemberJoinDay: (
            teamId: number,
            teamMemberId: number,
            data: TeamMemberJoinDayUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<TeamMemberSupportDto, any>({
                path: `/support/v1/teams/${teamId}/members/${teamMemberId}/join-day`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags scheduled-post-support-controller
         * @name ScheduledPostSupportControllerGet
         * @request GET:/support/v1/scheduled-posts/{id}
         * @secure
         */
        scheduledPostSupportControllerGet: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ScheduledPostDto, any>({
                path: `/support/v1/scheduled-posts/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags scheduled-post-support-controller
         * @name ScheduledPostSupportControllerUpdate
         * @request PUT:/support/v1/scheduled-posts/{id}
         * @secure
         */
        scheduledPostSupportControllerUpdate: (
            id: number,
            data: ScheduledPostRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<ScheduledPostDto, any>({
                path: `/support/v1/scheduled-posts/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags scheduled-post-support-controller
         * @name ScheduledPostSupportControllerDelete
         * @request DELETE:/support/v1/scheduled-posts/{id}
         * @secure
         */
        scheduledPostSupportControllerDelete: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/scheduled-posts/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-member-support-controller
         * @name CommunityMemberSupportControllerUpdateCommunityMemberTags
         * @request PUT:/support/v1/community-members/{communityMemberId}/tags
         * @secure
         */
        communityMemberSupportControllerUpdateCommunityMemberTags: (
            communityMemberId: number,
            data: CommunityMemberUpdateTagsRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityMemberSupportListEntryDto, any>({
                path: `/support/v1/community-members/${communityMemberId}/tags`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-member-support-controller
         * @name CommunityMemberSupportControllerUpdateCommunityMemberRole
         * @request PUT:/support/v1/community-members/{communityMemberId}/role
         * @secure
         */
        communityMemberSupportControllerUpdateCommunityMemberRole: (
            communityMemberId: number,
            data: CommunityMemberRoleUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityMemberSupportListEntryDto, any>({
                path: `/support/v1/community-members/${communityMemberId}/role`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-member-support-controller
         * @name CommunityMemberSupportControllerUpdateCommunityMemberJoinDay
         * @request PUT:/support/v1/community-members/{communityMemberId}/join-day
         * @secure
         */
        communityMemberSupportControllerUpdateCommunityMemberJoinDay: (
            communityMemberId: number,
            data: CommunityMemberJoinDayUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityMemberSupportListEntryDto, any>({
                path: `/support/v1/community-members/${communityMemberId}/join-day`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerSetRole
         * @request PUT:/support/v1/communities/{tenantId}/members/{userId}/role
         * @secure
         */
        communitySupportControllerSetRole: (
            tenantId: string,
            userId: string,
            data: CommunitySetRoleRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${tenantId}/members/${userId}/role`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerUpdateCommunity
         * @request PUT:/support/v1/communities/{id}
         * @secure
         */
        communitySupportControllerUpdateCommunity: (
            id: number,
            data: CommunityUpdateRequestSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityDetailsSupportDto, any>({
                path: `/support/v1/communities/${id}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerUpdateWhitelabel
         * @request PUT:/support/v1/communities/{id}/whitelabel
         * @secure
         */
        communitySupportControllerUpdateWhitelabel: (
            id: number,
            data: CommunityWhitelabelUpdateSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityDetailsSupportDto, any>({
                path: `/support/v1/communities/${id}/whitelabel`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerUpdateJoinConsents
         * @request PUT:/support/v1/communities/{id}/join-consents
         * @secure
         */
        communitySupportControllerUpdateJoinConsents: (
            id: number,
            data: ConsentUpdateDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityDetailsSupportDto, any>({
                path: `/support/v1/communities/${id}/join-consents`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-settings-support-controller
         * @name CommunitySettingsSupportControllerGetGeneralSettings
         * @request GET:/support/v1/communities/{communityId}/settings
         * @secure
         */
        communitySettingsSupportControllerGetGeneralSettings: (
            communityId: number,
            params: RequestParams = {}
        ) =>
            this.request<CommunitySettingsSupportDto, any>({
                path: `/support/v1/communities/${communityId}/settings`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-settings-support-controller
         * @name CommunitySettingsSupportControllerUpdateGeneralSettings
         * @request PUT:/support/v1/communities/{communityId}/settings
         * @secure
         */
        communitySettingsSupportControllerUpdateGeneralSettings: (
            communityId: number,
            data: CommunitySettingsSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunitySettingsSupportDto, any>({
                path: `/support/v1/communities/${communityId}/settings`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-settings-support-controller
         * @name CommunitySettingsSupportControllerGetLeaderboardSettings
         * @request GET:/support/v1/communities/{communityId}/leaderboard-settings
         * @secure
         */
        communitySettingsSupportControllerGetLeaderboardSettings: (
            communityId: number,
            params: RequestParams = {}
        ) =>
            this.request<CommunityLeaderboardSettingsSupportDto, any>({
                path: `/support/v1/communities/${communityId}/leaderboard-settings`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-settings-support-controller
         * @name CommunitySettingsSupportControllerUpdateLeaderboardSettings
         * @request PUT:/support/v1/communities/{communityId}/leaderboard-settings
         * @secure
         */
        communitySettingsSupportControllerUpdateLeaderboardSettings: (
            communityId: number,
            data: CommunityLeaderboardSettingsUpdateRequest,
            params: RequestParams = {}
        ) =>
            this.request<CommunityLeaderboardSettingsSupportDto, any>({
                path: `/support/v1/communities/${communityId}/leaderboard-settings`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-geo-restriction-support-controller
         * @name CommunityGeoRestrictionSupportControllerUpdate
         * @request PUT:/support/v1/communities/{communityId}/geo-restrictions/{restrictionId}
         * @deprecated
         * @secure
         */
        communityGeoRestrictionSupportControllerUpdate: (
            communityId: number,
            restrictionId: number,
            data: GeoRestrictionRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityGeoRestrictionDto, any>({
                path: `/support/v1/communities/${communityId}/geo-restrictions/${restrictionId}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-geo-restriction-support-controller
         * @name CommunityGeoRestrictionSupportControllerDelete
         * @request DELETE:/support/v1/communities/{communityId}/geo-restrictions/{restrictionId}
         * @deprecated
         * @secure
         */
        communityGeoRestrictionSupportControllerDelete: (
            communityId: number,
            restrictionId: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${communityId}/geo-restrictions/${restrictionId}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-budget-support-controller
         * @name CommunityBudgetSupportControllerChangeBudget
         * @request PUT:/support/v1/communities/{communityId}/budgets/{currencyCode}
         * @secure
         */
        communityBudgetSupportControllerChangeBudget: (
            communityId: number,
            currencyCode: string,
            data: CommunityBudgetChangeRequestSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${communityId}/budgets/${currencyCode}`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-budget-support-controller
         * @name CommunityBudgetSupportControllerDeleteBudget
         * @request DELETE:/support/v1/communities/{communityId}/budgets/{currencyCode}
         * @secure
         */
        communityBudgetSupportControllerDeleteBudget: (
            communityId: number,
            currencyCode: string,
            query: {
                comment: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${communityId}/budgets/${currencyCode}`,
                method: 'DELETE',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdateRules
         * @request PUT:/support/v1/challenges/{id}/rules
         * @secure
         */
        challengeSupportControllerUpdateRules: (
            id: number,
            data: ChallengeRuleConfigUpdateDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeDetailsSupportDto, any>({
                path: `/support/v1/challenges/${id}/rules`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdateReward
         * @request PUT:/support/v1/challenges/{id}/reward
         * @secure
         */
        challengeSupportControllerUpdateReward: (
            id: number,
            data: ChallengeRewardConfigDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeDetailsSupportDto, any>({
                path: `/support/v1/challenges/${id}/reward`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdatePresentation
         * @request PUT:/support/v1/challenges/{id}/presentation
         * @secure
         */
        challengeSupportControllerUpdatePresentation: (
            id: number,
            data: ChallengePresentationSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeDetailsSupportDto, any>({
                path: `/support/v1/challenges/${id}/presentation`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdateJoinConsents
         * @request PUT:/support/v1/challenges/{id}/join-consents
         * @secure
         */
        challengeSupportControllerUpdateJoinConsents: (
            id: number,
            data: ChallengeJoinConsentUpdateDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeDetailsSupportDto, any>({
                path: `/support/v1/challenges/${id}/join-consents`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdateGroupRules
         * @request PUT:/support/v1/challenges/{id}/group-rules
         * @secure
         */
        challengeSupportControllerUpdateGroupRules: (
            id: number,
            data: ChallengeGroupRulesUpdateDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeDetailsSupportDto, any>({
                path: `/support/v1/challenges/${id}/group-rules`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerGetTeamMemberResults
         * @request GET:/support/v1/challenge-team-subscriptions/{id}/member-results
         * @secure
         */
        challengeSupportControllerGetTeamMemberResults: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeTeamMemberResultsSupportDto, any>({
                path: `/support/v1/challenge-team-subscriptions/${id}/member-results`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdateTeamMemberResults
         * @request PUT:/support/v1/challenge-team-subscriptions/{id}/member-results
         * @secure
         */
        challengeSupportControllerUpdateTeamMemberResults: (
            id: number,
            data: ChallengeTeamMemberResultsUpdateRequestSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeTeamMemberResultsSupportDto, any>({
                path: `/support/v1/challenge-team-subscriptions/${id}/member-results`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerGetTeamDailyResults
         * @request GET:/support/v1/challenge-team-subscriptions/{id}/daily-results
         * @secure
         */
        challengeSupportControllerGetTeamDailyResults: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeTeamDailyResultsSupportDto, any>({
                path: `/support/v1/challenge-team-subscriptions/${id}/daily-results`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdateTeamDailyResults
         * @request PUT:/support/v1/challenge-team-subscriptions/{id}/daily-results
         * @secure
         */
        challengeSupportControllerUpdateTeamDailyResults: (
            id: number,
            data: ChallengeTeamDailyResultsUpdateRequestSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeTeamDailyResultsSupportDto, any>({
                path: `/support/v1/challenge-team-subscriptions/${id}/daily-results`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdateMemberResult
         * @request PUT:/support/v1/challenge-member-subscriptions/{id}/result
         * @secure
         */
        challengeSupportControllerUpdateMemberResult: (
            id: number,
            data: ChallengeMemberResultUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeLeaderboardEntrySupportDto, any>({
                path: `/support/v1/challenge-member-subscriptions/${id}/result`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdateMemberJoinDate
         * @request PUT:/support/v1/challenge-member-subscriptions/{id}/join-date
         * @secure
         */
        challengeSupportControllerUpdateMemberJoinDate: (
            id: number,
            data: ChallengeMemberJoinDateUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeLeaderboardEntrySupportDto, any>({
                path: `/support/v1/challenge-member-subscriptions/${id}/join-date`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdateMemberDisplaySettings
         * @request PUT:/support/v1/challenge-member-subscriptions/{id}/display-settings
         * @secure
         */
        challengeSupportControllerUpdateMemberDisplaySettings: (
            id: number,
            data: ChallengeMemberDisplaySettingsUpdateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeLeaderboardEntrySupportDto, any>({
                path: `/support/v1/challenge-member-subscriptions/${id}/display-settings`,
                method: 'PUT',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-location-support-controller
         * @name CommunityLocationSupportControllerGetPage
         * @request GET:/support/v2/communities/{communityId}/locations
         * @secure
         */
        communityLocationSupportControllerGetPage: (
            communityId: number,
            query?: {
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageCommunityLocationDto, any>({
                path: `/support/v2/communities/${communityId}/locations`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-location-support-controller
         * @name CommunityLocationSupportControllerCreate
         * @request POST:/support/v2/communities/{communityId}/locations
         * @secure
         */
        communityLocationSupportControllerCreate: (
            communityId: number,
            data: CommunityLocationRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityLocationDto, any>({
                path: `/support/v2/communities/${communityId}/locations`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerGenerateInvitationCode
         * @request POST:/support/v1/teams/{id}/invitation-code
         * @secure
         */
        teamSupportControllerGenerateInvitationCode: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<InvitationCodeDto, any>({
                path: `/support/v1/teams/${id}/invitation-code`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags scheduled-post-support-controller
         * @name ScheduledPostSupportControllerGetPage
         * @request GET:/support/v1/scheduled-posts
         * @secure
         */
        scheduledPostSupportControllerGetPage: (
            query?: {
                status?: ScheduledPostStatus;
                /** @format int64 */
                communityId?: number;
                /** @format date-time */
                publishFrom?: string;
                /** @format date-time */
                publishTo?: string;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageScheduledPostDto, any>({
                path: `/support/v1/scheduled-posts`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags scheduled-post-support-controller
         * @name ScheduledPostSupportControllerCreate
         * @request POST:/support/v1/scheduled-posts
         * @secure
         */
        scheduledPostSupportControllerCreate: (
            data: ScheduledPostRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<ScheduledPostDto, any>({
                path: `/support/v1/scheduled-posts`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags scheduled-post-support-controller
         * @name ScheduledPostSupportControllerSchedule
         * @request POST:/support/v1/scheduled-posts/{id}/schedule
         * @secure
         */
        scheduledPostSupportControllerSchedule: (
            id: number,
            data: SchedulePostRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<ScheduledPostDto, any>({
                path: `/support/v1/scheduled-posts/${id}/schedule`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags scheduled-post-support-controller
         * @name ScheduledPostSupportControllerRetry
         * @request POST:/support/v1/scheduled-posts/{id}/retry
         * @secure
         */
        scheduledPostSupportControllerRetry: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ScheduledPostDto, any>({
                path: `/support/v1/scheduled-posts/${id}/retry`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags scheduled-post-support-controller
         * @name ScheduledPostSupportControllerCancelSchedule
         * @request POST:/support/v1/scheduled-posts/{id}/cancel-schedule
         * @secure
         */
        scheduledPostSupportControllerCancelSchedule: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ScheduledPostDto, any>({
                path: `/support/v1/scheduled-posts/${id}/cancel-schedule`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags scheduled-post-support-controller
         * @name ScheduledPostSupportControllerValidateAuthorMembership
         * @request POST:/support/v1/scheduled-posts/validate-author-membership
         * @secure
         */
        scheduledPostSupportControllerValidateAuthorMembership: (
            data: ValidateAuthorMembershipRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<AuthorMembershipResultDto, any>({
                path: `/support/v1/scheduled-posts/validate-author-membership`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags image-support-controller
         * @name ImageSupportControllerUpload
         * @request POST:/support/v1/images
         * @secure
         */
        imageSupportControllerUpload: (
            query: {
                type: ImageType;
            },
            data: {
                /** @format binary */
                file: File;
            },
            params: RequestParams = {}
        ) =>
            this.request<CdnObjectDto, any>({
                path: `/support/v1/images`,
                method: 'POST',
                query: query,
                body: data,
                secure: true,
                type: ContentType.FormData,
                format: 'json',
                ...params
            }),

        /**
         * No description
         *
         * @tags community-member-support-controller
         * @name CommunityMemberSupportControllerCopyMemberToCommunity
         * @request POST:/support/v1/copy-member-to-community
         * @secure
         */
        communityMemberSupportControllerCopyMemberToCommunity: (
            query: {
                /** @minLength 1 */
                userId: string;
                /** @format int64 */
                fromCommunityId: number;
                /** @format int64 */
                toCommunityId: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/copy-member-to-community`,
                method: 'POST',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-result-support-controller
         * @name CommunityResultSupportControllerGenerateResults
         * @request POST:/support/v1/community-results
         * @secure
         */
        communityResultSupportControllerGenerateResults: (
            data: CommunityResultSupportRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityResultSupportResponseDto[], any>({
                path: `/support/v1/community-results`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-result-support-controller
         * @name CommunityResultSupportControllerInitMetrics
         * @request POST:/support/v1/community-member-result-metrics-inits
         * @secure
         */
        communityResultSupportControllerInitMetrics: (
            data: CommunityMemberResultMetricsInit,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/community-member-result-metrics-inits`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-settings-support-controller
         * @name CommunitySettingsSupportControllerSyncCommunityFeed
         * @request POST:/support/v1/community-feed-syncs
         * @secure
         */
        communitySettingsSupportControllerSyncCommunityFeed: (
            data: CommunityFeedSyncRequest,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/community-feed-syncs`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerGetPage
         * @request GET:/support/v1/communities
         * @secure
         */
        communitySupportControllerGetPage: (
            query?: {
                visibility?: CommunityVisibility;
                whitelabelId?: string;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageCommunityPageEntrySupportDto, any>({
                path: `/support/v1/communities`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerCreate
         * @request POST:/support/v1/communities
         * @secure
         */
        communitySupportControllerCreate: (
            data: CommunityCreateRequestSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityDto, any>({
                path: `/support/v1/communities`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerTriggerWalletAccountSynchronization
         * @request POST:/support/v1/communities/{id}/wallet-account-synchronizations
         * @secure
         */
        communitySupportControllerTriggerWalletAccountSynchronization: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${id}/wallet-account-synchronizations`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerTriggerTenantMembersSynchronization
         * @request POST:/support/v1/communities/{id}/tenant-members-synchronizations
         * @secure
         */
        communitySupportControllerTriggerTenantMembersSynchronization: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${id}/tenant-members-synchronizations`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerCreateTeam
         * @request POST:/support/v1/communities/{communityId}/teams
         * @secure
         */
        teamSupportControllerCreateTeam: (
            communityId: number,
            data: TeamCreateSupportRequest,
            params: RequestParams = {}
        ) =>
            this.request<TeamDetailsSupportDto, any>({
                path: `/support/v1/communities/${communityId}/teams`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerSendRecapMessage
         * @request POST:/support/v1/communities/{communityId}/send-recap-message
         * @secure
         */
        communitySupportControllerSendRecapMessage: (
            communityId: number,
            data: CommunityRecapRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${communityId}/send-recap-message`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags goal-support-controller
         * @name GoalSupportControllerAssignCommunityMembers
         * @request POST:/support/v1/communities/{communityId}/goals/{goalKey}/assignments
         * @secure
         */
        goalSupportControllerAssignCommunityMembers: (
            communityId: number,
            goalKey: string,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${communityId}/goals/${goalKey}/assignments`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-geo-restriction-support-controller
         * @name CommunityGeoRestrictionSupportControllerGetRestrictions
         * @request GET:/support/v1/communities/{communityId}/geo-restrictions
         * @deprecated
         * @secure
         */
        communityGeoRestrictionSupportControllerGetRestrictions: (
            communityId: number,
            params: RequestParams = {}
        ) =>
            this.request<CommunityGeoRestrictionDto[], any>({
                path: `/support/v1/communities/${communityId}/geo-restrictions`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-geo-restriction-support-controller
         * @name CommunityGeoRestrictionSupportControllerCreate
         * @request POST:/support/v1/communities/{communityId}/geo-restrictions
         * @deprecated
         * @secure
         */
        communityGeoRestrictionSupportControllerCreate: (
            communityId: number,
            data: GeoRestrictionRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityGeoRestrictionDto, any>({
                path: `/support/v1/communities/${communityId}/geo-restrictions`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-facility-restriction-support-controller
         * @name CommunityFacilityRestrictionSupportControllerGetRestrictions
         * @request GET:/support/v1/communities/{communityId}/facility-restrictions
         * @secure
         */
        communityFacilityRestrictionSupportControllerGetRestrictions: (
            communityId: number,
            params: RequestParams = {}
        ) =>
            this.request<FacilityRestrictionDto[], any>({
                path: `/support/v1/communities/${communityId}/facility-restrictions`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-facility-restriction-support-controller
         * @name CommunityFacilityRestrictionSupportControllerAddRestriction
         * @request POST:/support/v1/communities/{communityId}/facility-restrictions
         * @secure
         */
        communityFacilityRestrictionSupportControllerAddRestriction: (
            communityId: number,
            data: FacilityRestrictionCreateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<FacilityRestrictionDto, any>({
                path: `/support/v1/communities/${communityId}/facility-restrictions`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerGetPage
         * @request GET:/support/v1/challenges
         * @secure
         */
        challengeSupportControllerGetPage: (
            query?: {
                communityIds?: number[];
                statuses?: ChallengeStatus[];
                /** @format date-time */
                dateFrom?: string;
                /** @format date-time */
                dateTo?: string;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageChallengePageEntrySupportDto, any>({
                path: `/support/v1/challenges`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerCreate
         * @request POST:/support/v1/challenges
         * @secure
         */
        challengeSupportControllerCreate: (
            data: CommunityChallengeCreateRequestDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeDetailsSupportDto, any>({
                path: `/support/v1/challenges`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerUpdatePositions
         * @request POST:/support/v1/challenges/{id}/update-positions
         * @secure
         */
        challengeSupportControllerUpdatePositions: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/challenges/${id}/update-positions`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerMigrateAverageCalculationToV2
         * @request POST:/support/v1/challenges/{id}/migrate-average-calculation-v2
         * @secure
         */
        challengeSupportControllerMigrateAverageCalculationToV2: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeAverageCalculationMigrationSupportDto, any>({
                path: `/support/v1/challenges/${id}/migrate-average-calculation-v2`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerGetLeaderboardEntries
         * @request GET:/support/v1/challenges/{id}/leaderboard-entries
         * @secure
         */
        challengeSupportControllerGetLeaderboardEntries: (
            id: number,
            query?: {
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
                type?: ChallengeSubscriptionType;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageChallengeLeaderboardEntrySupportDto, any>({
                path: `/support/v1/challenges/${id}/leaderboard-entries`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerAddLeaderboardEntry
         * @request POST:/support/v1/challenges/{id}/leaderboard-entries
         * @secure
         */
        challengeSupportControllerAddLeaderboardEntry: (
            id: number,
            data: ChallengeLeaderboardEntryCreateRequestSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeLeaderboardEntrySupportDto, any>({
                path: `/support/v1/challenges/${id}/leaderboard-entries`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerGenerateInvitationCode
         * @request POST:/support/v1/challenges/{id}/invitation-code
         * @secure
         */
        challengeSupportControllerGenerateInvitationCode: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<InvitationCodeDto, any>({
                path: `/support/v1/challenges/${id}/invitation-code`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerRecalculateMemberSubscription
         * @request POST:/support/v1/challenge-member-subscriptions/{id}/recalculate
         * @secure
         */
        challengeSupportControllerRecalculateMemberSubscription: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<BasicLeaderboardEntryDto, any>({
                path: `/support/v1/challenge-member-subscriptions/${id}/recalculate`,
                method: 'POST',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-budget-support-controller
         * @name CommunityBudgetSupportControllerCorrectUsage
         * @request POST:/support/v1/budget-usages/{usageId}/corrections
         * @secure
         */
        communityBudgetSupportControllerCorrectUsage: (
            usageId: number,
            data: CommunityBudgetUsageCorrectionRequestSupportDto,
            params: RequestParams = {}
        ) =>
            this.request<CommunityBudgetUsageSupportDto, any>({
                path: `/support/v1/budget-usages/${usageId}/corrections`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags job-controller
         * @name JobControllerTriggerJob
         * @request POST:/support/jobs/{job}
         * @secure
         */
        jobControllerTriggerJob: (
            job: Job,
            data: Record<string, string>,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/jobs/${job}`,
                method: 'POST',
                body: data,
                secure: true,
                type: ContentType.Json,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller-v-2
         * @name CommunitySupportControllerV2Get
         * @request GET:/support/v2/communities/{id}
         * @secure
         */
        communitySupportControllerV2Get: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<CommunityDetailsSupportDto, any>({
                path: `/support/v2/communities/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerDeleteCommunity
         * @request DELETE:/support/v2/communities/{id}
         * @secure
         */
        communitySupportControllerDeleteCommunity: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v2/communities/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags user-support-controller
         * @name UserSupportControllerGetCommunityMembershipInfo
         * @request GET:/support/v1/users/{userId}/community-membership-info
         * @secure
         */
        userSupportControllerGetCommunityMembershipInfo: (
            userId: string,
            params: RequestParams = {}
        ) =>
            this.request<CommunityMembershipInfoSupportDto, any>({
                path: `/support/v1/users/${userId}/community-membership-info`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerGetPage
         * @request GET:/support/v1/teams
         * @secure
         */
        teamSupportControllerGetPage: (
            query?: {
                /** @format int64 */
                communityId?: number;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageTeamSupportDto, any>({
                path: `/support/v1/teams`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerGetMembers
         * @request GET:/support/v1/teams/{teamId}/members
         * @secure
         */
        teamSupportControllerGetMembers: (
            teamId: number,
            query?: {
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageTeamMemberSupportDto, any>({
                path: `/support/v1/teams/${teamId}/members`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-support-controller
         * @name TeamSupportControllerExportMembers
         * @request GET:/support/v1/teams/{teamId}/members/export
         * @secure
         */
        teamSupportControllerExportMembers: (
            teamId: number,
            query?: {
                search?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/teams/${teamId}/members/export`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags admin-leaderboard-preview-support-controller
         * @name AdminLeaderboardPreviewSupportControllerPreviewTeamMembers
         * @request GET:/support/v1/teams/{teamId}/leaderboard-preview/members
         * @secure
         */
        adminLeaderboardPreviewSupportControllerPreviewTeamMembers: (
            teamId: number,
            query: {
                leaderboardMetric: LeaderboardMetric;
                /** @format date */
                dateFrom: string;
                /** @format date */
                dateTo: string;
                aggregation?: AggregationAlgorithm;
                /** @format date-time */
                dataCutoffTimestamp?: string;
                workoutCategory?: WorkoutCategory;
                workoutType?: WorkoutTypeV2;
                currencyCode?: string;
                compositePointTypeKey?: string;
                includeEmails?: boolean;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 10000
                 */
                size?: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<AdminLeaderboardMemberPreviewResponse, any>({
                path: `/support/v1/teams/${teamId}/leaderboard-preview/members`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-feed-support-controller
         * @name TeamFeedSupportControllerGetFeed
         * @request GET:/support/v1/teams/{teamId}/feed
         * @secure
         */
        teamFeedSupportControllerGetFeed: (
            teamId: number,
            query?: {
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 */
                limit?: number;
                next?: string;
                /** @format date-time */
                fromCreatedAt?: string;
                /** @format date-time */
                toCreatedAt?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<SupportFeedPageDto, any>({
                path: `/support/v1/teams/${teamId}/feed`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-feed-support-controller
         * @name TeamFeedSupportControllerGetFeedComments
         * @request GET:/support/v1/teams/{teamId}/feed/{activityId}/comments
         * @secure
         */
        teamFeedSupportControllerGetFeedComments: (
            teamId: number,
            activityId: string,
            query?: {
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 */
                limit?: number;
                next?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<SupportFeedCommentPageDto, any>({
                path: `/support/v1/teams/${teamId}/feed/${activityId}/comments`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-feed-support-controller
         * @name TeamFeedSupportControllerPinFeedActivity
         * @request PUT:/support/v1/teams/{teamId}/feed/{activityId}/pin
         * @secure
         */
        teamFeedSupportControllerPinFeedActivity: (
            teamId: number,
            activityId: string,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/teams/${teamId}/feed/${activityId}/pin`,
                method: 'PUT',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags team-feed-support-controller
         * @name TeamFeedSupportControllerUnpinFeedActivity
         * @request DELETE:/support/v1/teams/{teamId}/feed/{activityId}/pin
         * @secure
         */
        teamFeedSupportControllerUnpinFeedActivity: (
            teamId: number,
            activityId: string,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/teams/${teamId}/feed/${activityId}/pin`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-member-support-controller
         * @name CommunityMemberSupportControllerGetCommunityMembers
         * @request GET:/support/v1/community-members
         * @secure
         */
        communityMemberSupportControllerGetCommunityMembers: (
            query: {
                /** @format int64 */
                communityId: number;
                memberRole?: CommunityMemberRole;
                verified?: boolean;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageCommunityMemberSupportListEntryDto, any>({
                path: `/support/v1/community-members`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-member-support-controller
         * @name CommunityMemberSupportControllerExportCommunityMembers
         * @request GET:/support/v1/community-members/export
         * @secure
         */
        communityMemberSupportControllerExportCommunityMembers: (
            query: {
                /** @format int64 */
                communityId: number;
                memberRole?: CommunityMemberRole;
                verified?: boolean;
                search?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/community-members/export`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-support-controller
         * @name CommunitySupportControllerGet
         * @request GET:/support/v1/communities/{tenantId}
         * @secure
         */
        communitySupportControllerGet: (
            tenantId: string,
            params: RequestParams = {}
        ) =>
            this.request<CommunityDto, any>({
                path: `/support/v1/communities/${tenantId}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags admin-leaderboard-preview-support-controller
         * @name AdminLeaderboardPreviewSupportControllerPreviewCommunityTeams
         * @request GET:/support/v1/communities/{communityId}/leaderboard-preview/teams
         * @secure
         */
        adminLeaderboardPreviewSupportControllerPreviewCommunityTeams: (
            communityId: number,
            query: {
                leaderboardMetric: LeaderboardMetric;
                /** @format date */
                dateFrom: string;
                /** @format date */
                dateTo: string;
                aggregation?: AggregationAlgorithm;
                /** @format date-time */
                dataCutoffTimestamp?: string;
                workoutCategory?: WorkoutCategory;
                workoutType?: WorkoutTypeV2;
                currencyCode?: string;
                compositePointTypeKey?: string;
                includeEmails?: boolean;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 10000
                 */
                size?: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<AdminTeamLeaderboardPreviewResponse, any>({
                path: `/support/v1/communities/${communityId}/leaderboard-preview/teams`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags admin-leaderboard-preview-support-controller
         * @name AdminLeaderboardPreviewSupportControllerPreviewCommunityMembers
         * @request GET:/support/v1/communities/{communityId}/leaderboard-preview/members
         * @secure
         */
        adminLeaderboardPreviewSupportControllerPreviewCommunityMembers: (
            communityId: number,
            query: {
                leaderboardMetric: LeaderboardMetric;
                /** @format date */
                dateFrom: string;
                /** @format date */
                dateTo: string;
                aggregation?: AggregationAlgorithm;
                /** @format date-time */
                dataCutoffTimestamp?: string;
                workoutCategory?: WorkoutCategory;
                workoutType?: WorkoutTypeV2;
                currencyCode?: string;
                compositePointTypeKey?: string;
                includeEmails?: boolean;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 10000
                 */
                size?: number;
            },
            params: RequestParams = {}
        ) =>
            this.request<AdminLeaderboardMemberPreviewResponse, any>({
                path: `/support/v1/communities/${communityId}/leaderboard-preview/members`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-feed-support-controller
         * @name CommunityFeedSupportControllerGetFeed
         * @request GET:/support/v1/communities/{communityId}/feed
         * @secure
         */
        communityFeedSupportControllerGetFeed: (
            communityId: number,
            query?: {
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 */
                limit?: number;
                next?: string;
                /** @format date-time */
                fromCreatedAt?: string;
                /** @format date-time */
                toCreatedAt?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<SupportFeedPageDto, any>({
                path: `/support/v1/communities/${communityId}/feed`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-feed-support-controller
         * @name CommunityFeedSupportControllerGetFeedComments
         * @request GET:/support/v1/communities/{communityId}/feed/{activityId}/comments
         * @secure
         */
        communityFeedSupportControllerGetFeedComments: (
            communityId: number,
            activityId: string,
            query?: {
                /**
                 * @format int32
                 * @min 1
                 * @max 100
                 */
                limit?: number;
                next?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<SupportFeedCommentPageDto, any>({
                path: `/support/v1/communities/${communityId}/feed/${activityId}/comments`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-feed-support-controller
         * @name CommunityFeedSupportControllerPinFeedActivity
         * @request PUT:/support/v1/communities/{communityId}/feed/{activityId}/pin
         * @secure
         */
        communityFeedSupportControllerPinFeedActivity: (
            communityId: number,
            activityId: string,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${communityId}/feed/${activityId}/pin`,
                method: 'PUT',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-feed-support-controller
         * @name CommunityFeedSupportControllerUnpinFeedActivity
         * @request DELETE:/support/v1/communities/{communityId}/feed/{activityId}/pin
         * @secure
         */
        communityFeedSupportControllerUnpinFeedActivity: (
            communityId: number,
            activityId: string,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${communityId}/feed/${activityId}/pin`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-budget-support-controller
         * @name CommunityBudgetSupportControllerGetBudgets
         * @request GET:/support/v1/communities/{communityId}/budgets
         * @secure
         */
        communityBudgetSupportControllerGetBudgets: (
            communityId: number,
            params: RequestParams = {}
        ) =>
            this.request<CommunityBudgetSupportDto, any>({
                path: `/support/v1/communities/${communityId}/budgets`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-budget-support-controller
         * @name CommunityBudgetSupportControllerGetPeriods
         * @request GET:/support/v1/communities/{communityId}/budget-periods
         * @secure
         */
        communityBudgetSupportControllerGetPeriods: (
            communityId: number,
            query: {
                currencyCode?: string;
                fromMonth: string;
                toMonth: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<CommunityBudgetPeriodSupportDto[], any>({
                path: `/support/v1/communities/${communityId}/budget-periods`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerGetDetails
         * @request GET:/support/v1/challenges/{id}
         * @secure
         */
        challengeSupportControllerGetDetails: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<ChallengeDetailsSupportDto, any>({
                path: `/support/v1/challenges/${id}`,
                method: 'GET',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerDelete
         * @request DELETE:/support/v1/challenges/{id}
         * @secure
         */
        challengeSupportControllerDelete: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/challenges/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerGetTeamLeaderboardEntries
         * @request GET:/support/v1/challenges/{id}/team-leaderboard-entries
         * @secure
         */
        challengeSupportControllerGetTeamLeaderboardEntries: (
            id: number,
            query?: {
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
                type?: ChallengeSubscriptionType;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageChallengeTeamLeaderboardEntrySupportDto, any>({
                path: `/support/v1/challenges/${id}/team-leaderboard-entries`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-photo-support-controller
         * @name ChallengePhotoSupportControllerGetAvailablePhotos
         * @request GET:/support/v1/challenge-photos
         * @secure
         */
        challengePhotoSupportControllerGetAvailablePhotos: (
            query?: {
                /** @format int32 */
                size?: number;
                continuationToken?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<ChallengePhotoSearchResponseDto, any>({
                path: `/support/v1/challenge-photos`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-budget-support-controller
         * @name CommunityBudgetSupportControllerGetUsages
         * @request GET:/support/v1/budget-usages
         * @secure
         */
        communityBudgetSupportControllerGetUsages: (
            query: {
                /** @format int64 */
                communityId: number;
                currencyCode?: string;
                yearMonth?: string;
                userId?: string;
                /**
                 * @format int32
                 * @min 0
                 */
                page?: number;
                /**
                 * @format int32
                 * @exclusiveMin 0
                 * @max 1000
                 */
                size?: number;
                search?: string;
                sort?: string;
            },
            params: RequestParams = {}
        ) =>
            this.request<PageCommunityBudgetUsageSupportDto, any>({
                path: `/support/v1/budget-usages`,
                method: 'GET',
                query: query,
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags community-facility-restriction-support-controller
         * @name CommunityFacilityRestrictionSupportControllerRemoveRestriction
         * @request DELETE:/support/v1/communities/{communityId}/facility-restrictions/{restrictionId}
         * @secure
         */
        communityFacilityRestrictionSupportControllerRemoveRestriction: (
            communityId: number,
            restrictionId: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/communities/${communityId}/facility-restrictions/${restrictionId}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerRemoveTeamLeaderboardEntry
         * @request DELETE:/support/v1/challenge-team-subscriptions/{id}
         * @secure
         */
        challengeSupportControllerRemoveTeamLeaderboardEntry: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/challenge-team-subscriptions/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            }),

        /**
         * No description
         *
         * @tags challenge-support-controller
         * @name ChallengeSupportControllerRemoveLeaderboardEntry
         * @request DELETE:/support/v1/challenge-member-subscriptions/{id}
         * @secure
         */
        challengeSupportControllerRemoveLeaderboardEntry: (
            id: number,
            params: RequestParams = {}
        ) =>
            this.request<void, any>({
                path: `/support/v1/challenge-member-subscriptions/${id}`,
                method: 'DELETE',
                secure: true,
                ...params
            })
    };
}
